import styled from 'styled-components';

import { Button, Link, media } from '@minerva-analytics/pantheon';

import { WHITE } from 'root/theme';

const HomeContainer = styled.div`
  background-color: ${WHITE};
`;

const HeroContent = styled.div`
  max-width: 500px;
  height: 100%;
  padding: 1em 1em 0 2rem;
  ${media.tablet`
    margin: 0 auto;
    text-align: center;
    padding-top: 0;
  `}
`;

const HeroTitle = styled.h1`
    color: ${WHITE};
    
    ${media.tablet`
      font-size: 2.5rem;
      line-height: 3.5rem;
    `}
    ${media.phone`
      font-size: 2rem;
    `}
  `;

const HeroSubtitle = styled.h3`
  padding: 1rem 0 2rem;
  color: ${WHITE};
  ${media.tablet`
    font-size: 1.25rem;
  `}
`;


const QuizWrap = styled.div`
  background-color: ${WHITE};
  margin: 0 auto;
  max-width: 1024px;
  padding: 3rem 2rem;
`;

const QuizSelectionButtons = styled.div`
  display: flex;
  flex-direction: column;
  ${media.tablet`
    align-items: center;
  `}
`;

const RandomQuizButton = styled(Button).attrs({
  color: WHITE,
})`
  width: 250px;
  border: none;
  text-decoration: underline;

`;

const ChooseQuizButton = styled(Button)`
  width: 250px;
`;

const ChooseLink = styled(Link)`
`;

export {
  HeroTitle,
  HeroSubtitle,
  HeroContent,
  HomeContainer,
  QuizWrap,
  QuizSelectionButtons,
  ChooseQuizButton,
  RandomQuizButton,
  ChooseLink,
};
